/**
 * @file axios.js
 * @brief Configuración de axios para producción y desarrollo
 */

import axios from 'axios';

// En producción, las rutas son relativas (proxy de Apache)
// En desarrollo, usa el proxy configurado en package.json
const baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:6000';

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios;
